import Checkbox, { Checkbox as NotPureCheckbox } from './Checkbox';
import * as Types from './Checkbox.d';
import { CheckBox, StyledLabel, CheckboxWrapper } from './Checkbox.styled';

export { NotPureCheckbox as Checkbox, CheckBox, StyledLabel, CheckboxWrapper };
export type CheckboxPropsBase = Types.CheckboxPropsBase;
export type CheckboxProps = Types.CheckboxProps;
export default Checkbox;
